<template>
  <PageWrapper :hasFilters="!isRenderingLinkBtn" @submitFilters="setFilters">
    <template #title> نرخ ریزش کاربر ها </template>
    <template #titleBtn v-if="isRenderingLinkBtn">
      <BButton
        variant="success"
        to="/dashboard/analytics/user-reports-by-period"
      >
        جزئیات
      </BButton>
    </template>
    <template #filters v-if="!isRenderingLinkBtn">
      <RangeDatePicker
        inputId="firstFromToRangeDateForUserReports"
        class="w-24 filters-width"
        label="بازه‌ی تاریخ اول"
        :defaultDateRange="firstDefaultDateRange"
        @getDateRange="setFirstRangeDate"
      ></RangeDatePicker>
      <RangeDatePicker
        inputId="secondFromToRangeDateForUserReports"
        class="w-24 filters-width"
        label="بازه‌ی تاریخ دوم"
        :defaultDateRange="secondDefaultDateRange"
        @getDateRange="setSecondRangeDate"
      ></RangeDatePicker>
    </template>
    <GeneralLineChart
      ref="chart"
      :getChartData="getUserReportsByDate"
    ></GeneralLineChart>
    <template v-if="!isRenderingLinkBtn">
      <h5 class="mb-1">کاربر های غیر فعال در بازه‌ی انتخابی</h5>
      <BOverlay :show="isLoading">
        <CustomTable
          ref="inactiveUsersTable"
          :pageNumber="userReportByDateTimeFilters.globalGrid.pageNumber"
          :count="userReportByDateTimeFilters.globalGrid.count"
          :totalCount="inactiveTotalCount"
          :tableColumns="tableColumns"
          :tableItems="inactiveUsers"
          @changePage="changePage"
        >
          <template #index="data">
            {{
              Math.ceil(
                data.index +
                  1 +
                  (userReportByDateTimeFilters.globalGrid.pageNumber - 1) *
                    userReportByDateTimeFilters.globalGrid.count
              )
            }}
          </template>
          <template #fullName="data">
            <b-link :to="`/users/${data.item.userId}`">
              {{ data.item.fullName }}
            </b-link>
          </template>
        </CustomTable>
      </BOverlay>
    </template>
  </PageWrapper>
</template>

<script>
export default {
  props: {
    isRenderingLinkBtn: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  mounted() {
    this.setDatesFromQuery();
    if (this.computedPageRouteQuery) {
      this.userReportByDateTimeFilters.globalGrid.pageNumber =
        this.computedPageRouteQuery;
    } else {
      this.userReportByDateTimeFilters.globalGrid.pageNumber = 1;
    }
  },
  data() {
    return {
      isLoading: false,
      firstDefaultDateRange: [],
      secondDefaultDateRange: [],
      userReportDetails: null,
      userReportByDateTimeFilters: {
        firstStartDate: null,
        firstEndDate: null,
        secondStartDate: null,
        secondEndDate: null,
        globalGrid: {
          pageNumber: 1,
          count: 10,
        },
      },
      activeUsers: null,
      inactiveUsers: null,
      inactiveTotalCount: null,
      tableColumns: [
        {
          key: "index",
          label: "ردیف",
        },
        {
          key: "fullName",
          label: "نام شاگرد",
        },
      ],
    };
  },
  methods: {
    changePage(pageNumber) {
      this.setPageNumberQuery(pageNumber);
      this.userReportByDateTimeFilters.globalGrid.pageNumber = pageNumber;
      this.setFilters(false);
    },
    setFilters(resetChart = true) {
      this.$refs?.chart?.sendChartRequest(resetChart);
      this.setFilterToQuery();
    },
    setFirstRangeDate(rangeDate) {
      if (rangeDate && rangeDate.length > 0) {
        this.userReportByDateTimeFilters.firstStartDate = new Date(
          rangeDate[0]
        ).toISOString();
        this.userReportByDateTimeFilters.firstEndDate = new Date(
          rangeDate[1]
        ).toISOString();
      } else {
        this.userReportByDateTimeFilters.firstStartDate = null;
        this.userReportByDateTimeFilters.firstEndDate = null;
      }
    },
    setSecondRangeDate(rangeDate) {
      if (rangeDate && rangeDate.length > 0) {
        this.userReportByDateTimeFilters.secondStartDate = new Date(
          rangeDate[0]
        ).toISOString();
        this.userReportByDateTimeFilters.secondEndDate = new Date(
          rangeDate[1]
        ).toISOString();
      } else {
        this.userReportByDateTimeFilters.secondStartDate = null;
        this.userReportByDateTimeFilters.secondEndDate = null;
      }
    },
    setDatesFromQuery() {
      const queries = this.$route.query;
      if (queries.frs && queries.fre && queries.srs && queries.sre) {
        this.firstDefaultDateRange = [
          this.splitByDatePart(new Date(+queries.frs).toISOString()),
          this.splitByDatePart(new Date(+queries.fre).toISOString()),
        ];
        this.secondDefaultDateRange = [
          this.splitByDatePart(new Date(+queries.srs).toISOString()),
          this.splitByDatePart(new Date(+queries.sre).toISOString()),
        ];
      }
    },
    setFilterToQuery() {
      if (
        this.userReportByDateTimeFilters.firstStartDate &&
        this.userReportByDateTimeFilters.firstEndDate &&
        this.userReportByDateTimeFilters.secondStartDate &&
        this.userReportByDateTimeFilters.secondEndDate
      ) {
        const frs = new Date(
          this.userReportByDateTimeFilters.firstStartDate
        ).getTime(); // First Range Start
        const fre = new Date(
          this.userReportByDateTimeFilters.firstEndDate
        ).getTime(); // First Range End

        const srs = new Date(
          this.userReportByDateTimeFilters.secondStartDate
        ).getTime(); // Second Range Start
        const sre = new Date(
          this.userReportByDateTimeFilters.secondEndDate
        ).getTime(); // Second Range End

        this.$router.push({
          path: this.$route.path,
          query: {
            ...this.$route.query,
            frs,
            fre,
            srs,
            sre,
          },
        });
      }
    },
    splitByDatePart(isoDate) {
      return isoDate.split("T")[0];
    },
    async calculateDatePeriods() {
      return new Promise((resolve, reject) => {
        let firstStartDate = new Date(
          new Date().setDate(new Date().getDate() - 30)
        ).toISOString();
        let firstEndDate = new Date(
          new Date().setDate(new Date().getDate() - 15)
        ).toISOString();

        let secondStartDate = new Date(
          new Date().setDate(new Date().getDate() - 15)
        ).toISOString();
        let secondEndDate = new Date().toISOString();
        this.firstDefaultDateRange = [
          this.splitByDatePart(firstStartDate),
          this.splitByDatePart(firstEndDate),
        ];
        this.secondDefaultDateRange = [
          this.splitByDatePart(secondStartDate),
          this.splitByDatePart(secondEndDate),
        ];
        this.userReportByDateTimeFilters.firstStartDate = firstStartDate;
        this.userReportByDateTimeFilters.firstEndDate = firstEndDate;
        this.userReportByDateTimeFilters.secondStartDate = secondStartDate;
        this.userReportByDateTimeFilters.secondEndDate = secondEndDate;
        resolve();
      });
    },
    async getUserReportsByDate(_this) {
      const that = this;
      if (!this.userReportByDateTimeFilters.firstStartDate) {
        await this.calculateDatePeriods();
      }
      try {
        that.isLoading = true;
        const getUsersReportByDateTime = new GetUsersReportByDateTime(_this);
        getUsersReportByDateTime.setRequestParamDataObj(
          this.userReportByDateTimeFilters
        );
        await getUsersReportByDateTime.fetch((res) => {
          if (res.isSuccess) {
            that.inactiveUsers = res.data.data.inActiveUsers;
            that.inactiveTotalCount = res.data.inActiveUsersCount;
            _this.chartOptions.series = [];
            let firstDataArray = [];
            let secondDataArray = [];
            let myLabelArray = [];

            if (res.data.firstDiff && res.data.firstDiff.length) {
              for (let i = 0; i < res.data.firstDiff.length; i++) {
                myLabelArray.push(i + 1);
                firstDataArray.push(res.data.firstDiff[i].totalUsers);
                secondDataArray.push(res.data.secoundDiff[i].totalUsers);
              }
            }
            _this.chartOptions.series.push({
              name: `بازه اول (<b>${this.customFullDateConvert(
                this.userReportByDateTimeFilters.firstStartDate
              )}</b> - <b>${this.customFullDateConvert(
                this.userReportByDateTimeFilters.firstEndDate
              )}</b>)`,
              data: firstDataArray,
            });
            _this.chartOptions.series.push({
              name: `بازه دوم (<b>${this.customFullDateConvert(
                this.userReportByDateTimeFilters.secondStartDate
              )}</b> - <b>${this.customFullDateConvert(
                this.userReportByDateTimeFilters.secondEndDate
              )})</b>`,
              data: secondDataArray,
            });
            _this.chartOptions["xaxis"]["categories"] = myLabelArray;

            _this.chartOptions.tooltip.custom = ({
              series,
              seriesIndex,
              dataPointIndex,
              w,
            }) => {
              const firstWeekData = w.globals.initialSeries[0];
              const secondWeekData = w.globals.initialSeries[1];
              return (
                "<ul style='padding: 0 !important; margin: 0 !important; padding: 0.5rem 1rem !important;'>" +
                `<li style='list-style-type: none;'><b>بازه اول</b>: ` +
                `${firstWeekData.data[dataPointIndex]} نفر` +
                "</li>" +
                `<li style='list-style-type: none;'><b>بازه دوم</b>: ` +
                `${secondWeekData.data[dataPointIndex]} نفر` +
                "</li>" +
                "</ul>"
              );
            };
          }
          _this.isRenderingChart = true;
        });
      } catch (error) {
        console.error(error);
      } finally {
        that.isLoading = false;
      }
    },
    setPageNumberQuery(pageNumber) {
      this.$router.replace({
        path: this.$route.path,
        query: {
          inactivePage: pageNumber,
        },
      });
    },
  },
  computed: {
    computedPageRouteQuery() {
      if (this.$route.query && this.$route.query.inactivePage) {
        return this.$route.query.inactivePage;
      }
      return null;
    },
  },
  mixins: [timeConvertUtils],
  components: {
    PageWrapper,
    GeneralLineChart,
    BButton,
    BLink,
    RangeDatePicker,
    CustomTable,
    BOverlay,
  },
};

import PageWrapper from "@/views/components/Utils/PageWrapper.vue";
import GeneralLineChart from "@/views/dashboard/analytics/UserReport/GeneralLineChart.vue";
import RangeDatePicker from "@/views/components/Utils/RangeDatePicker.vue";
import timeConvertUtils from "@/mixins/timeConvertUtils";
import CustomTable from "@/views/components/Utils/CustomTable.vue";
import { GetUsersReportByDateTime } from "@/libs/Api/Users";
import { BButton, BLink, BOverlay } from "bootstrap-vue";
</script>
